var utils = require( './utils' );

var zoom_image = ( function( $ ) {

	var $zoom_images;

	var _init = function() {
		$zoom_images = $( '.zoom-image-wrapper' );

		$.each( $zoom_images, function( index, $item ) {
			_setup_zoom_image( $item );
		} );
	};

	var _setup_zoom_image = function( $item ) {
		var $image_container = $( $item ),
			$image_url       = $image_container.data( 'image' );

		$image_container.append('<div class="zoom-image" style="background-image: url( '+ $image_url + ' )"></div>');

		_setup_zoom_events( $image_container );
	};

	var _setup_zoom_events = function( $image_container ) {
		var scale  = $image_container.data( 'scale' ),
			$image = $image_container.find( '.zoom-image' );

		if ( utils.viewport_size().width >= 992 ) {
			$image_container.on( 'mouseover', function() {
				_zoom_image( scale, $image );
			} );

			$image_container.on( 'mouseout', function() {
				_zoom_image( 1, $image );
			} );

			$image_container.on( 'mousemove', function( e ) {
				_change_zoom_origin( e, $image, $image_container )
			} );
		}
	};

	var _zoom_image = function ( scale, $image ) {
		$image.css( { 'transform': 'scale('+ scale +')' } );
	};

	var _change_zoom_origin = function( e, $image, $image_container ) {
		var origin_X = ( e.pageX - $image_container.offset().left ) / $image_container.width() * 100 + '%',
			origin_Y = ( e.pageY - $image_container.offset().top ) / $image_container.height() * 100 + '%';

		$image.css( { 'transform-origin': ( origin_X ) + ( origin_Y ) } );
	};

	if ( $( '.zoom-image-wrapper' ).length > 0 ) {
		$( document ).ready( _init );
	}

})( jQuery );

module.exports = zoom_image;